import React, { Component } from "react"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import FileSaver from "file-saver"
import _ from "lodash"
import { StyleSheet, css } from "aphrodite"
import firebase from "firebase"
import Select from "react-select"
import { connect } from "react-redux"
import { STATUS } from "../../constants/constants"
import axios from "axios"
import JSZip from "jszip"
import JSZipUtils from "jszip-utils"
import Modal from "react-modal"
import SearchStudent from "./SearchStudent"
import Spinner from "react-spinkit"
import $ from "jquery"
import Nav from "../../components/Nav/Nav"
// import uuidv4 from "uuid/v4";
import ImageViewer from "../../components/ImageViewer"

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "1024px",
    maxHeight: "800px",
  },
}

class DashBoard extends Component {
  pageLimit = 12
  loadStart
  loadLimit = 500
  loadData = []
  loadRound = 0

  state = {
    faculties: [],
    facultyId: null,
    status: STATUS.NONE,
    query: "",
    isModalOpen: false,

    isOpen: false,
    studentImg: "",
    studentId: "",

    //From Infinite Page
    noneElements: [],
    approvedElements: [],
    rejectedElements: [],
    downloadedElements: [],
    lastElementId: null,
    isMoreRecord: true,
    isInfiniteLoading: false,
    counter: {
      none: 0,
      approved: 0,
      rejected: 0,
      downloaded: 0,
    },
  }

  componentDidUpdate(prevProps, prevState) {
    const { status, facultyId } = this.state
    if (
      (prevState.status && status !== prevState.status) ||
      (facultyId !== prevState.facultyId && prevState.facultyId)
    ) {
      //   .once("value", (snapshot) => this.setState({ counter: snapshot.val() }))
      firebase
        .database()
        .ref(
          `ThammasatUniversity/statusFaculty/${
            facultyId === "all" ? "0" : facultyId
          }`
        )
        .once("value", (snapshot) => {
          this.setState(
            {
              counter: snapshot.val(),
              isInfiniteLoading: true,
              noneElements: [],
              approvedElements: [],
              rejectedElements: [],
              downloadedElements: [],
              lastElementId: null,
              isMoreRecord: true,
            },
            () => {
              this.loadData()
            }
          )
        })
    }
  }

  toggleModal = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  getMoveRawDataByStatusRef = async (
    updates = {},
    studentId = "0123456789",
    newStatus,
    reason
  ) => {
    const { universityFirebase } = this.props
    const rawDataByIdSnapshot = await firebase
      .database()
      .ref(`${universityFirebase}/rawDataById/${studentId}`)
      .once("value")
    const student = rawDataByIdSnapshot.val()

    if (student) {
      if (student.status) {
        const oldStatus = student.status

        await firebase
          .database()
          .ref(
            `${universityFirebase}/rawDataByStatusTest/${oldStatus}/${student.studentId}`
          )
          .remove()
      }

      //Set new status value
      student.status = newStatus
      if (student.status === STATUS.REJECTED) {
        student.isApproved = false
        student.reason = reason
      } else {
        student.isApproved = true
        student.reason = null
      }

      updates[
        `${universityFirebase}/rawDataByStatusTest/${newStatus}/${student.studentId}`
      ] = student
    }
  }

  deleteStudentDataAndImage = async (studentId) => {
    const { universityFirebase } = this.props
    const { status } = this.state

    const rawDataByIdSnapshot = await firebase
      .database()
      .ref(`${universityFirebase}/rawDataById/${studentId}`)
      .once("value")
    const student = rawDataByIdSnapshot.val()
    const downloadUri = student && student.downloadUri
    await firebase
      .database()
      .ref(`${universityFirebase}/rawDataById/${studentId}`)
      .remove()
    await firebase
      .database()
      .ref(`${universityFirebase}/rawDataByStatusTest/${status}/${studentId}`)
      .remove()

    if (downloadUri) {
      await firebase.storage().refFromURL(downloadUri).delete()
    }
  }

  loadData = async () => {
    const { universityFirebase } = this.props
    const { lastElementId, status, facultyId } = this.state

    let tmpLastElementId = lastElementId
    let newElements = []
    let isMoreRecord = true

    do {
      let rawDataRef = firebase
        .database()
        .ref(`${universityFirebase}/rawDataByStatusTest/${status}`)
        .orderByKey()

      //Start From Old Key
      if (tmpLastElementId) {
        rawDataRef = rawDataRef.startAt(tmpLastElementId)
      }

      //Calculate Remain Length
      const calculateLength = this.pageLimit + 1
      const snapshot = await rawDataRef
        .limitToFirst(calculateLength)
        .once("value")

      const values = snapshot.val() || {}

      const keys = Object.keys(values)
      const keyLength = keys.length
      let data = Object.values(values)

      //Set tmpLastElementId
      //For query next time
      if (keyLength === calculateLength) {
        let lastKey = keys.splice(-1, 1)
        tmpLastElementId = lastKey[0]
        data.splice(-1, 1)
      } else {
        isMoreRecord = false
      }

      let tmpFetchElements = _.filter(data, { status })

      //Filter result by Status
      // let tmpFetchElements = keys
      //   .map(key => {
      //     values[key].key = key;
      //     return values[key];
      //   })
      //   .filter(value => value.status === status);

      //Filter result by facultyId
      if (facultyId && facultyId !== "0" && facultyId !== "all") {
        tmpFetchElements = tmpFetchElements.filter((value) => {
          if (value.facultyId === 0 || value.facultyId && value.status) {
            return value.facultyId.toString() === facultyId.toString()
          }
          return false
        })
      }

      //Create newElements
      newElements = newElements.concat(tmpFetchElements)
      // console.log(++counter, newElements.length, snapshot.val())
    } while (newElements.length < this.pageLimit && isMoreRecord)

    //Concat newElements with previous elements
    newElements = this.state[`${status}Elements`].concat(newElements)
    this.setState({
      [`${status}Elements`]: newElements,
      lastElementId: tmpLastElementId,
      isInfiniteLoading: false,
      isMoreRecord,
    })
  }

  getFacultyNameById = (facultyId) => {
    return this.faculties[facultyId] || "ไม่ระบุ"
  }

  renderModal = () => {
    const { isModalOpen, query, faculties } = this.state
    const { universityFirebase } = this.props

    return (
      <Modal contentLabel="Modal" isOpen={isModalOpen} style={modalStyles}>
        <SearchStudent
          handleApproveClick={this.handleApproveClick}
          handleRejectClick={this.handleRejectClick}
          handleDeleteClick={this.handleDeleteClick}
          handleDownloadClick={this.handleDownloadClick}
          handleChangeRejectedReason={this.handleChangeRejectedReason}
          universityFirebase={universityFirebase}
          faculties={faculties}
          query={query}
          closeModal={() => this.setState({ isModalOpen: false, query: "" })}
        />
      </Modal>
    )
  }

  checkPermission = async (oldStatus, newStatus) => {
    const arrStatus = Object.values(STATUS)
    const indexOldStatus = arrStatus.indexOf(oldStatus)
    const indexNewStatus = arrStatus.indexOf(newStatus)

    if (indexOldStatus > indexNewStatus) {
      return false
    } else {
      return true
    }
  }

  checkDuplicateData = async (studentId, status) => {
    const { universityFirebase } = this.props

    // ตรวจสอบว่ามีรูปที่ได้รับการรับรอบแล้วหรือยัง
    const snapshot = await firebase
      .database()
      .ref(`${universityFirebase}/rawDataById/${studentId}`)
      .once("value")
    const student = snapshot.val()

    const permission = await this.checkPermission(
      student && student.status,
      status
    )
    if (permission) {
      return true
    } else {
      if (
        window.confirm(
          `${studentId}: มีรูปที่ได้รับการรับรองแล้ว\nต้องการลบข้อมูลหรือไม่?`
        )
      ) {
        console.log("click confirm", status, studentId)
        await firebase
          .database()
          .ref(
            `${universityFirebase}/rawDataByStatusTest/${status}/${studentId}`
          )
          .remove()
      }

      return false
    }
  }

  getBase64Image = async (url) => {
    const response = await fetch(url)
    const blob = await response.blob()
    const reader = new FileReader()
    await new Promise((resolve, reject) => {
      reader.onload = resolve
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
    return reader.result.replace(/^data:.+;base64,/, "")
  }

  // Completed
  handleApproveClick = async (
    status,
    studentId,
    email,
    callback,
    downloadUri
  ) => {
    const { universityFirebase } = this.props
    const elements = this.state[`${status}Elements`]
    const duplicate = await this.checkDuplicateData(studentId, status)
    if (!duplicate) {
      return
    }

    const base64 = await this.getBase64Image(downloadUri)

    // if(base64Reg.test(base64)) {
    //   console.log('base 64')
    // } else {
    //   const base64new = await this.getBase64Image(base64)
    //   console.log("base64new",base64new)
    // }
    // if(base64.test(/"^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$"/g)) {
    //   console.log('base64 :',base64)
    // }

    //Comfirm
    if (window.confirm(`Do you want to approve picture`)) {
      try {
        //Update List
        let updates = {}
        //Update rawData Status
        updates[`${universityFirebase}/rawDataById/${studentId}/status`] =
          STATUS.APPROVED
        updates[`${universityFirebase}/rawDataById/${studentId}/reason`] = ""
        updates[`${universityFirebase}/users/${studentId}/isApproved`] = true
        await this.getMoveRawDataByStatusRef(
          updates,
          studentId,
          STATUS.APPROVED
        )
        let tmpElements = elements.filter(
          (element) => studentId !== element.studentId
        )

        console.log("tmpElements :", tmpElements)

        //Update value


        if (callback && typeof callback === "function") {
          callback()
        }
        fetch("https://proxy-picnow.iapp.co.th/api-tupicnow/api/uploadimage", {
          method: "POST",
          body: JSON.stringify({
            studentcode: studentId,
            image: base64,
          }),
        })
          .then((res) => {
            if (res.status === 200) return res.json()
          })
          .then(async (json) => {
            if (json && json.status === "Y") {
              fetch(
                `https://us-central1-picnowtest.cloudfunctions.net/api/sendEmail?email=${email}&isApproved=true&studentId=${studentId}`
              )
              await firebase.database().ref().update(updates)
              this.setState({ [`${status}Elements`]: tmpElements })
            } else if (json && json.status === "N") {
              alert(json.description)
            }
          })
        // .then((json) => console.log("json :", json))
        // fetch(`https://us-central1-picnowtest.cloudfunctions.net/api/sendEmail?email=${email}&isApproved=true&studentId=${studentId}`);
        // this.setState({ [`${status}Elements`]: tmpElements });
      } catch (error) {
        console.log("Error", error)
      }
    }
  }

  // Completed
  handleRejectClick = async (studentId, email, callback) => {
    console.log("click")
    const { universityFirebase } = this.props
    const { status } = this.state
    const elements = this.state[`${status}Elements`]

    const duplicate = await this.checkDuplicateData(studentId, status)

    console.log("duplicate :", duplicate)
    if (!duplicate) {
      return
    }

    //Confirm
    let reason = window.prompt(
      "กรุณาระบุเหตุผลของการไม่อนุมัติ",
      "รูปไม่ได้คุณภาพเพียงพอ"
    )
    if (reason) {
      try {
        //Make update list
        const updates = {}
        updates[`/${universityFirebase}/rawDataById/${studentId}/status`] =
          STATUS.REJECTED
        updates[
          `/${universityFirebase}/rawDataById/${studentId}/reason`
        ] = reason
        updates[`/${universityFirebase}/users/${studentId}/isApproved`] = false
        await this.getMoveRawDataByStatusRef(
          updates,
          studentId,
          STATUS.REJECTED,
          reason
        )
        const tmpElements = elements.filter(
          (element) => studentId !== element.studentId
        )

        //Update value
        await firebase.database().ref().update(updates)
        if (callback && typeof callback === "function") {
          callback()
        }

        fetch(
          `https://us-central1-picnowtest.cloudfunctions.net/api/sendEmail?email=${email}&isApproved=false&msg=${reason}&studentId=${studentId}`
        )
        this.setState({ [`${status}Elements`]: tmpElements })
      } catch (error) {
        console.log("Error", error)
      }
    }
  }

  toStatusDownload = async (universityFirebase, studentId) => {
    let updates = {}
    updates[`${universityFirebase}/rawDataById/${studentId}/status`] =
      STATUS.DOWNLOADED
    await this.getMoveRawDataByStatusRef(updates, studentId, STATUS.DOWNLOADED)

    //Update value
    return firebase.database().ref().update(updates)
  }

  // Completed
  handleDownloadClick = async (studentId, status, callback) => {
    const { universityFirebase } = this.props
    const elements = this.state[`${status}Elements`]
    try {
      //Get Student
      let student = await firebase
        .database()
        .ref(`${universityFirebase}/rawDataByStatusTest/${status}`)
        .orderByKey()
        .equalTo(studentId)
        .once("value")

      if (status === STATUS.APPROVED) {
        this.toStatusDownload(universityFirebase, studentId)

        let tmpElements = elements.filter(
          (element) => studentId !== element.studentId
        )
        if (callback && typeof callback === "function") {
          callback()
        }
        this.setState({ [`${status}Elements`]: tmpElements })
      }

      let downloadUri = student.val()[studentId].downloadUri
      if (downloadUri) {
        // This can be downloaded directly:
        const reader = new FileReader()

        reader.onloadend = () => {
          const base64 = reader.result
          const link = document.createElement("a")

          link.setAttribute("href", base64)
          link.setAttribute("download", `${studentId}.jpg`)
          link.click()
        }
        axios
          .get(downloadUri, {
            responseType: "blob",
          })
          .then(function (response) {
            reader.readAsDataURL(response.data)
          })
      }
    } catch (error) {
      console.log("Error", error)
    }
  }

  // Completed
  handleDeleteClick = async (studentId, downloadUri, callback) => {
    // const { universityFirebase } = this.props;
    const { status } = this.state
    const elements = this.state[`${status}Elements`]
    if (window.confirm(`Do you want to remove picture`)) {
      try {
        //Delete Uri from Real-time
        await this.deleteStudentDataAndImage(studentId)

        //Delete studentId from elements
        let tmpElements = elements.filter(
          (element) => studentId !== element.studentId
        )

        if (callback && typeof callback === "function") {
          callback()
        }

        this.setState({ [`${status}Elements`]: tmpElements })
      } catch (error) {
        console.log("Error", error)
      }
    }
  }

  // Completed
  handleChangeRejectedReason = async (studentId, callback) => {
    const updates = {}
    const { universityFirebase } = this.props
    const { rejectedElements } = this.state
    try {
      const snapshot = await firebase
        .database()
        .ref(`${universityFirebase}/rawDataById/${studentId}`)
        .once("value")
      const data = snapshot.val()
      const reason = data.reason
      const email = data.emailAddress
      const status = data.status
      const newReason = window.prompt("แก้ไขข้อความ", reason)
      if (newReason) {
        updates[
          `${universityFirebase}/rawDataById/${studentId}/reason`
        ] = newReason
        updates[
          `${universityFirebase}/rawDataByStatusTest/${status}/${studentId}/reason`
        ] = newReason

        //Send email
        fetch(
          `https://us-central1-picnowtest.cloudfunctions.net/api/sendEmail?email=${email}&isApproved=false&msg=${newReason}&studentId=${studentId}`
        )

        //Update value
        firebase.database().ref().update(updates)

        if (callback && typeof callback === "function") {
          callback()
        }

        const newElements = rejectedElements.map((element) => {
          if (element.key === studentId) {
            element.reason = newReason
          }
          return element
        })

        this.setState({ rejectedElements: newElements })
      }
    } catch (error) {
      console.error("handleChangeRejectedReason", error)
    }
  }

  // Completed
  handleDeleteAllClick = async (callback) => {
    const { universityFirebase } = this.props
    const { status } = this.state

    if (window.confirm(`Do you want to remove all picture`)) {
      try {
        //Delete Uri from Real-time

        let allData = await firebase
          .database()
          .ref(`${universityFirebase}/rawDataById`)
          .orderByChild("status")
          .equalTo(STATUS.DOWNLOADED)
          .once("value")
        allData = Object.values(allData.val())

        const length = allData.length
        for (let i = 0; i < length; i++) {
          const studentId = allData[i].studentId
          const downloadUri = allData[i].downloadUri

          this.deleteStudentDataAndImage(studentId)

          //Delete Pic from Storage
          await firebase.storage().refFromURL(downloadUri).delete()
        }

        if (callback && typeof callback === "function") {
          callback()
        }

        //Clear elements
        this.setState({ [`${status}Elements`]: [] })
      } catch (error) {
        console.log("Error", error)
      }
    }
  }

  // Completed
  handleSelectedApproveClick = async () => {
    const { universityFirebase } = this.props
    const { status } = this.state
    const elements = this.state[`${status}Elements`]

    let selectedElements = elements.filter((element) => element.checked)
    let tmpElements = elements
      .filter((element) => !element.checked)
      .map((element) => {
        element.checked = false
        return element
      })
    console.log("selectedElements :", selectedElements)
    //Do it has selectedElements
    if (selectedElements.length > 0) {
      const updates = {}
      const length = selectedElements.length
      //Confirm
      if (window.confirm("Do you want to approve selected item(s)?")) {
        try {
          //Loop SelectedElements
          for (let index = 0; index < length; index++) {
            const studentId = selectedElements[index].studentId
            const email = selectedElements[index].emailAddress
            const base64 = this.getBase64Image(
              selectedElements[index].downloadUri
            )
            updates[`${universityFirebase}/rawDataById/${studentId}/status`] =
              STATUS.APPROVED
            updates[
              `${universityFirebase}/rawDataById/${studentId}/isApproved`
            ] = true
            await this.getMoveRawDataByStatusRef(
              updates,
              studentId,
              STATUS.APPROVED
            )

            fetch(
              "https://proxy-picnow.iapp.co.th/api-tupicnow/api/uploadimage",
              {
                method: "POST",
                body: JSON.stringify({
                  studentcode: studentId,
                  image: base64,
                }),
              }
            )
              .then((res) => {
                if (res.status === 200) return res.json()
              })
              .then((json) => {
                fetch(
                  `https://us-central1-picnowtest.cloudfunctions.net/api/sendEmail?email=${email}&isApproved=true&studentId=${studentId}`
                )
              })
            // fetch(
            //   `https://us-central1-picnowtest.cloudfunctions.net/api/sendEmail?email=${email}&isApproved=true&studentId=${studentId}`
            // )
          }

          //Update Firebase
          await firebase.database().ref().update(updates)

          this.setState({ [`${status}Elements`]: tmpElements })
        } catch (error) {
          console.error("[Event] handleSelectedApproveClick", error)
        }
      }
    } else {
      alert("You didn't check any checkboxes")
    }
  }

  // Completed
  handleSelectedRejectClick = async () => {
    const { universityFirebase } = this.props
    const { status } = this.state
    const elements = this.state[`${status}Elements`]
    let selectedElements = elements.filter((element) => element.checked)
    let tmpElements = elements
      .filter((element) => !element.checked)
      .map((element) => {
        element.checked = false
        return element
      })

    //selectedElements
    if (selectedElements.length > 0) {
      let updates = {}
      let length = selectedElements.length
      const reason = window.prompt(
        "กรุณากรอกสาเหตุที่ไม่อนุมัติ",
        "รูปไม่ได้คุณภาพ"
      )
      if (reason) {
        try {
          //Loop SelectedElements
          for (let index = 0; index < length; index++) {
            const email = selectedElements[index].emailAddress
            const studentId = selectedElements[index].studentId
            updates[`${universityFirebase}/rawDataById/${studentId}/status`] =
              STATUS.REJECTED
            updates[
              `${universityFirebase}/rawDataById/${studentId}/reason`
            ] = reason
            updates[
              `${universityFirebase}/rawDataById/${studentId}/isApproved`
            ] = false
            await this.getMoveRawDataByStatusRef(
              updates,
              studentId,
              STATUS.REJECTED
            )
            fetch(
              `https://us-central1-picnowtest.cloudfunctions.net/api/sendEmail?email=${email}&isApproved=false&msg=${reason}&studentId=${studentId}`
            )
          }
          //Update Firebase
          await firebase.database().ref().update(updates)

          this.setState({ [`${status}Elements`]: tmpElements })
        } catch (error) {
          console.error("[Event] handleSelectedRejectedClick", error)
        }
      }
    } else {
      alert("You didn't check any checkboxes")
    }
  }

  handleSelectedDownloadClick = async () => {
    const { universityFirebase } = this.props
    const { status } = this.state
    const elements = this.state[`${status}Elements`]
    let selectedElements = elements.filter((element) => element.checked)
    let tmpElements = elements
      .filter((element) => !element.checked)
      .map((element) => {
        element.checked = false
        return element
      })

    try {
      if (selectedElements.length > 0) {
        this.setState({ isSelectDownloadLoading: true }, async () => {
          await this.imageTozip(selectedElements)
          await this.upDownloadApprove(
            selectedElements,
            status,
            universityFirebase
          )
        })
      } else {
        alert("You didn't check any checkboxes")
      }
      this.setState({ [`${status}Elements`]: tmpElements })
    } catch (error) {
      console.error("[Event] handleSelectedDownloadClick", error)
    } finally {
      this.setState({ isSelectDownloadLoading: false })
    }
  }

  // Completed
  handleSelectedDeleteClick = async () => {
    const { universityFirebase } = this.props
    const { status } = this.state
    const elements = this.state[`${status}Elements`]
    let selectedElements = elements.filter((element) => element.checked)
    let tmpElements = elements
      .filter((element) => !element.checked)
      .map((element) => {
        element.checked = false
        return element
      })

    //Selected Delete
    if (selectedElements.length > 0) {
      let length = selectedElements.length
      if (window.confirm("Do you want to delete selected item(s)")) {
        try {
          for (let index = 0; index < length; index++) {
            const downloadUri = selectedElements[index].downloadUri
            const studentId = selectedElements[index].studentId

            //Delete Data from Real-time
            const updates = {}
            updates[`${universityFirebase}/rawDataById/${studentId}`] = null
            this.deleteStudentDataAndImage(studentId)

            await firebase.database().ref().update(updates)

            //Delete Pic from Storage
            await firebase.storage().refFromURL(downloadUri).delete()
          }
          this.setState({ [`${status}Elements`]: tmpElements })
        } catch (error) {
          console.error("[Event] handleSelectedRejectedClick", error)
        }
      }
    } else {
      alert("You didn't check any checkboxes")
    }
  }

  // Completed
  handleDownloadAllClick = async (status) => {
    if (window.confirm("Do you want to download all?")) {
      this.setState({ isAllDownloadLoading: true }, async () => {
        try {
          await this.chunkDownload(status)
        } catch (error) {
          console.error("[Event] handleDownloadAllClick", error)
        } finally {
          this.setState({ isAllDownloadLoading: false })
        }
      })
    }
  }

  chunkDownload = async (status) => {
    const { universityFirebase } = this.props

    //Get Student
    let snapshot = firebase
      .database()
      .ref(`${universityFirebase}/rawDataByStatusTest/${status}`)
      .orderByKey()

    let limit = this.loadLimit
    if (this.loadStart) {
      snapshot = snapshot.startAt(this.loadStart)
      limit++
    }
    snapshot = await snapshot.limitToFirst(limit).once("value")
    const values = snapshot.val()

    let array = Object.values(values)
    if (this.loadStart) {
      array.shift()
    }
    let len = array.length
    console.log("chunkDownload len: ", len)

    if (len > 0) {
      this.loadRound++
      this.loadData = [...this.loadData, ...array]

      await this.imageTozip(array, this.loadRound)
      if (len >= this.loadLimit) {
        this.loadStart = array[len - 1].studentId || this.loadStart
        return await this.chunkDownload(status)
      }
    }

    await this.upDownloadApprove(this.loadData, status, universityFirebase)
    this.loadStart = undefined
    this.loadRound = 0
    return
  }

  upDownloadApprove = async (arr, status, universityFirebase) => {
    console.log("upDownloadApprove: ", arr.length, status, universityFirebase)
    if (status === STATUS.APPROVED) {
      return Promise.all(
        arr.map(async (e) => {
          let studentId = e.studentId
          await this.toStatusDownload(universityFirebase, studentId)
        })
      )
    }
    return
  }

  imageTozip = async (array, round) => {
    const length = array.length
    const chunk = _.chunk(array, 1000)

    if (length > 0) {
      for (var k in chunk) {
        const zip = new JSZip()

        await Promise.all(
          chunk[k].map(async (e) => {
            let studentId = e.studentId
            let downloadUri = e.downloadUri

            if (downloadUri) {
              let data = await this.getBinaryContent(downloadUri).catch(
                (err) => {
                  console.error("getBinaryContent: ", studentId, downloadUri)
                }
              )
              zip.folder("Images").file(`${studentId}.jpg`, data, {
                binary: true,
              })
            }

            return zip
          })
        )

        //Generate and download zip
        let blob = await zip.generateAsync({ type: "blob" })
        FileSaver.saveAs(
          blob,
          "All Picture " + (round || Number(k) + 1) + ".zip"
        )
      }
    } else {
      alert("No data to download")
    }
    return
  }

  getBinaryContent = (uri) => {
    return new Promise((resolve, reject) => {
      return JSZipUtils.getBinaryContent(uri, (err, data) =>
        err ? reject(err) : resolve(data)
      )
    })
  }

  selectStatusByIndex = (index) => {
    let status
    switch (index) {
      case 0:
        status = STATUS.NONE
        break
      case 1:
        status = STATUS.APPROVED
        break
      case 2:
        status = STATUS.REJECTED
        break
      case 3:
        status = STATUS.DOWNLOADED
        break
      default:
        status = STATUS.NONE
        break
    }
    return status
  }

  elementInfiniteLoad = () => {
    const { isInfiniteLoading } = this.state
    return (
      <div className="infinite-list-item">
        {isInfiniteLoading && <h3>Loading...</h3>}
      </div>
    )
  }

  handleInfiniteLoad = () => {
    const { isMoreRecord } = this.state
    if (isMoreRecord) {
      this.setState(
        {
          isInfiniteLoading: true,
        },
        () => {
          this.loadData()
        }
      )
    }
  }

  handleCheckbox = (event, keyGet) => {
    const { status } = this.state
    const elements = this.state[`${status}Elements`]

    let tmpElements = elements.map((element, index) => {
      if (element.studentId === keyGet) {
        element.checked = event.target.checked
        return element
      }
      return element
    })

    this.setState({ [`${status}Elements`]: tmpElements })
  }

  renderImageViewer = () => {
    let { studentId, studentImg } = this.state
    return (
      <ImageViewer
        show={this.state.isOpen}
        onClose={this.toggleModal}
        title={studentId}
        imgHolder={studentImg}
      />
    )
  }

  setImageViewer = (event, student) => {
    this.toggleModal()
    this.setState({
      studentId: student.studentId,
      studentImg: student.downloadUri,
    })
  }

  _renderElementItems = (element) => {
    return element.map((item, index) => (
      <div
        key={item.studentId}
        className={`col-xs-12 col-sm-6 col-md-3 text-center ${css(
          styles.imgContainer
        )}`}
      >
        <img
          className={css(styles.img)}
          alt={"รูปภาพ"}
          src={item.downloadUri}
          onClick={(event) => this.setImageViewer(event, item)}
        />
        <h4 className={"bold"} style={{ minHeight: "40px" }}>
          {this.getFacultyNameById(item.facultyId)}
        </h4>

        <div className={`btn-group `}>
          {item.status !== STATUS.DOWNLOADED && (
            <button
              className={"btn btn-warning disabled"}
              style={{ opacity: 1 }}
            >
              <input
                type={"checkbox"}
                checked={item.checked}
                onChange={(event) => this.handleCheckbox(event, item.studentId)}
              />
            </button>
          )}

          <button
            className={`btn btn-primary bold ${css(styles.btn120)} disabled`}
            style={{
              opacity: 1,
              fontSize: "1.6rem",
              paddingBottom: 5,
              paddingTop: 5,
            }}
          >
            {item.studentId}
          </button>

          {(item.status === STATUS.NONE || item.status === STATUS.REJECTED) && (
            <button
              className={`btn btn-success`}
              onClick={() =>
                this.handleApproveClick(
                  item.status,
                  item.studentId,
                  item.emailAddress,
                  null,
                  item.downloadUri
                )
              }
            >
              <span className={"glyphicon glyphicon-ok"} />
            </button>
          )}

          {(item.status === STATUS.NONE ||
            item.status === STATUS.APPROVED ||
            item.status === STATUS.DOWNLOADED) && (
            <button
              className={`btn btn-danger`}
              onClick={() =>
                this.handleRejectClick(item.studentId, item.emailAddress)
              }
            >
              <span className={"glyphicon glyphicon-remove"} />
            </button>
          )}

          {item.status === STATUS.REJECTED && (
            <button
              className={`btn btn-danger`}
              onClick={() =>
                this.handleDeleteClick(item.studentId, item.downloadUri)
              }
            >
              <span className={"glyphicon glyphicon-trash"} />
            </button>
          )}

          {(item.status === STATUS.APPROVED ||
            item.status === STATUS.DOWNLOADED) && (
            <button
              className={`btn btn-success`}
              onClick={() =>
                this.handleDownloadClick(item.studentId, item.status)
              }
            >
              <span className={"glyphicon glyphicon-download"} />
            </button>
          )}
        </div>
        {item.status === STATUS.REJECTED && (
          <div className="row">
            <div className="col-md-12 text-center">
              <h4 className={css(styles.txtReject)}>
                {item.reason}
                &nbsp;
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={() =>
                    this.handleChangeRejectedReason(item.studentId)
                  }
                >
                  <span className={"glyphicon glyphicon-repeat"} />
                </button>
              </h4>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col text-center">
            <span>{item.dateTime}</span>
          </div>
        </div>
      </div>
    ))
  }

  _renderElements = (elements) => {

    return (
      <div className={"element-items"}>
        <br />
        {_.chunk(_.filter(elements,{ status: this.state.status }),4).map((element, index) => (
          <div key={index}>
            <div className={"row"}>{this._renderElementItems(element)}</div>
            <br />
          </div>
        ))}
      </div>
    )
  }

  componentDidMount() {
    const { universityFirebase } = this.props
    //Get Faculties list
    firebase
      .database()
      .ref(`${universityFirebase}/faculties`)
      .once("value")
      .then((snapshot) => {
        this.faculties = snapshot.val()
        const faculties = Object.entries(this.faculties).map((item, index) => ({
          value: item[0],
          label: item[1],
        }))
        faculties.unshift({ value: "all", label: "Select Filter" })
        this.setState({ faculties, facultyId: faculties[0].value })
      })

    //bind scroll for infinite load
    // let lineFromBottom = $("footer").outerHeight(true);

    $(() => {
      // Handler for .ready() called.
      $(".element-box").bind("scroll", () => {
        var Hi = $(".element-items").height() //height of page
        var scrollBottom =
          $(".element-box").scrollTop() + $(".element-box").height() //distance from edge of top To bottom of window
        if (
          scrollBottom >= Hi - 80 &&
          !this.state.isInfiniteLoading &&
          this.state.isMoreRecord
        ) {
          this.handleInfiniteLoad()
        }
      })
    })

    //Watch Change Status
    firebase
      .database()
      .ref(`${universityFirebase}/statusFaculty/0`)
      .on("value", (snapshot) => {
        this.setState({ counter: snapshot.val() })
      })

    //Load data
    this.setState({ isInfiniteLoading: true }, () => {
      this.loadData()
    })
  }

  handleSearchClick = (event) => {
    event.preventDefault()
    this.setState({ isModalOpen: true })
  }

  isDisplay = (status) => {
    if (status === STATUS.DOWNLOADED) {
      return "disappear"
    }
  }

  handleSelectAllClick = (event) => {
    event.preventDefault()
    const { status } = this.state
    const tmpElements = this.state[`${status}Elements`].map((element) => {
      element.checked = true
      return element
    })
    this.setState({ [`${status}Elements`]: tmpElements })
  }

  handleDeselectAllClick = (event) => {
    event.preventDefault()
    const { status } = this.state
    const tmpElements = this.state[`${status}Elements`].map((element) => {
      element.checked = false
      return element
    })
    this.setState({ [`${status}Elements`]: tmpElements })
  }

  handleRemoveClick = async (event) => {
    event.preventDefault()
    const { universityFirebase } = this.props
    const { remove } = this.state

    console.log("remove: ", remove)

    let snapshot = await firebase
      .database()
      .ref(`${universityFirebase}/rawData`)
      .orderByChild("fileName")
      .equalTo(remove)
      .once("value")

    const values = snapshot.val()
    console.log("values: ", values)
  }

  render() {
    const {
      facultyId,
      faculties,
      status,
      isInfiniteLoading,
      isAllDownloadLoading,
      isSelectDownloadLoading,
      counter,
    } = this.state
    const elements = this.state[`${status}Elements`]

    return (
      <div>
        {this.renderImageViewer()}
        <Nav />
        <div className={"row"}>
          <div className={"col-md-12"}>
            <div className={"row"}>
              <div className={"col-md-12"}>
                {this.renderModal()}
                <form className="form-horizontal">
                  <div className={"row"}>
                    <div className={"col-md-5"}>
                      <div className="form-group has-feedback">
                        <label
                          htmlFor={"search"}
                          className="col-md-3 control-label"
                        >
                          Search
                        </label>
                        <div className="col-md-7">
                          <input
                            type="text"
                            className="form-control"
                            name="search"
                            onChange={(event) =>
                              this.setState({ query: event.target.value })
                            }
                            value={this.state.query}
                          />
                          <span className="glyphicon glyphicon-search form-control-feedback" />
                        </div>
                        <div className={"col-md-2"}>
                          <button
                            className={"btn btn-primary btn-sm"}
                            onClick={this.handleSearchClick}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                      {
                        // <div className="form-group has-feedback">
                        //   <label htmlFor={"search"} className="col-md-3 control-label">
                        //     Remove
                        //   </label>
                        //   <div className="col-md-7">
                        //     <input
                        //       type="text"
                        //       className="form-control"
                        //       name="remove"
                        //       onChange={event => this.setState({ remove: event.target.value })}
                        //       value={this.state.remove}
                        //     />
                        //     <span className="glyphicon glyphicon-search form-control-feedback" />
                        //   </div>
                        //   <div className={"col-md-2"}>
                        //     <button className={"btn btn-primary btn-sm"} onClick={this.handleRemoveClick}>
                        //       Remove
                        //     </button>
                        //   </div>
                        // </div>
                      }
                    </div>
                    <div className={"col-md-4"}>
                      <div className="form-group has-feedback">
                        <label className="col-md-3 control-label">
                          Faculty
                        </label>
                        <div className="col-md-9">
                          <Select
                            value={facultyId}
                            options={faculties}
                            onChange={(value) =>
                              this.setState({ facultyId: value.value })
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className={"col-md-3 text-right"}>
                      <button
                        className={`btn btn-success ${css(
                          styles[this.isDisplay(status)]
                        )} `}
                        onClick={(event) => this.handleSelectAllClick(event)}
                      >
                        Select All
                      </button>
                      &nbsp;&nbsp;
                      <button
                        className={`btn btn-danger ${css(
                          styles[this.isDisplay(status)]
                        )} `}
                        onClick={(event) => this.handleDeselectAllClick(event)}
                      >
                        Deselect All
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <br />
            <div className={"row text-center"} style={{ paddingBottom: "3%" }}>
              {(isAllDownloadLoading || isSelectDownloadLoading) && (
                <span>
                  <Spinner
                    name="three-bounce"
                    color="#337ab7"
                    className={`${css(styles.loadingAtDownload)}`}
                  />{" "}
                  Downloading
                </span>
              )}
            </div>
            <div className={"row"}>
              <div className={"col-md-12"}>
                <Tabs
                  forceRenderTabPanel={true}
                  onSelect={(index) =>
                    this.setState({ status: this.selectStatusByIndex(index) })
                  }
                >
                  <TabList>
                    <Tab>
                      New &nbsp;
                      <span className={`badge ${css(styles.badgePrimary)}`}>
                        {counter.none}
                      </span>
                      {status === STATUS.NONE && (
                        <button
                          className={`btn btn-danger btn-sm pull-right ${css(
                            styles.btnSpace
                          )}`}
                          onClick={() => this.handleSelectedRejectClick()}
                        >
                          Reject
                        </button>
                      )}
                      {status === STATUS.NONE && (
                        <button
                          className={`btn btn-success btn-sm pull-right ${css(
                            styles.btnSpace
                          )}`}
                          onClick={() => this.handleSelectedApproveClick()}
                        >
                          Approve
                        </button>
                      )}
                    </Tab>
                    <Tab>
                      Approved &nbsp;
                      <span className={`badge ${css(styles.badgePrimary)}`}>
                        {counter.approved}
                      </span>
                      {status === STATUS.APPROVED && (
                        <button
                          className={`btn btn-success btn-sm pull-right ${css(
                            styles.btnSpace
                          )}`}
                          onClick={() => this.handleSelectedDownloadClick()}
                        >
                          <i className="glyphicon glyphicon-download" />
                        </button>
                      )}
                      {status === STATUS.APPROVED && (
                        <button
                          className={`btn btn-primary btn-sm pull-right ${css(
                            styles.btnSpace
                          )}`}
                          onClick={() =>
                            this.handleDownloadAllClick(STATUS.APPROVED)
                          }
                        >
                          All
                        </button>
                      )}
                    </Tab>
                    <Tab>
                      Rejected &nbsp;
                      <span className={`badge ${css(styles.badgePrimary)}`}>
                        {counter.rejected}
                      </span>
                      {status === STATUS.REJECTED && (
                        <button
                          className={`btn btn-danger btn-sm pull-right ${css(
                            styles.btnSpace
                          )}`}
                          onClick={() => this.handleSelectedDeleteClick()}
                        >
                          Delete
                        </button>
                      )}
                    </Tab>

                    <Tab>
                      Download &nbsp;
                      <span className={`badge ${css(styles.badgePrimary)}`}>
                        {counter.downloaded}
                      </span>
                      {status === STATUS.DOWNLOADED && (
                        <button
                          className={`btn btn-danger btn-sm pull-right ${css(
                            styles.btnSpace
                          )}`}
                          onClick={() => this.handleDeleteAllClick()}
                        >
                          <i className="glyphicon glyphicon-trash" />
                        </button>
                      )}
                      {status === STATUS.DOWNLOADED && (
                        <button
                          className={`btn btn-primary btn-sm pull-right ${css(
                            styles.btnSpace
                          )}`}
                          onClick={() =>
                            this.handleDownloadAllClick(STATUS.DOWNLOADED)
                          }
                        >
                          <i className="glyphicon glyphicon-download" />
                        </button>
                      )}
                    </Tab>
                  </TabList>
                  <TabPanel />
                  <TabPanel />
                  <TabPanel />
                  <TabPanel />
                </Tabs>
                <div className={`${css(styles.infiniteContainer)} element-box`}>
                  {isInfiniteLoading && (
                    <Spinner
                      name="three-bounce"
                      color="#337ab7"
                      className={`text-center ${css(styles.loadingSym)}`}
                    />
                  )}
                  {!isInfiniteLoading && elements.length <= 0 && (
                    <h1 className={`text-center`}>Data not found</h1>
                  )}
                  {this._renderElements(elements)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return { universityFirebase: state.auth.universityFirebase }
}

export default connect(mapStateToProps)(DashBoard)

const styles = StyleSheet.create({
  txtReject: {
    fontWeight: "bold",
    color: "red",
  },
  imgContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  img: {
    width: "180px",
    height: "240px",
    objectFit: "cover",
    border: "1px solid lightgrey",
    marginBottom: "5px",
    borderRadius: "10px",
  },
  btn100: {
    width: "100px",
  },
  btn120: {
    width: "120px",
  },
  btnSpace: {
    marginRight: "4px",
    marginLeft: "4px",
  },
  infiniteContainer: {
    width: "100%",
    border: "1px solid #aaa",
    borderTop: "0px",
    marginTop: "-10px",
    height: "660px",
    overflow: "scroll",
  },
  loadingSym: {
    marginTop: "7%",
    marginBottom: "7%",
  },
  loadingAtDownload: {
    marginBottom: "2%",
  },
  textNotFound: {
    marginTop: "3%",
    marginBottom: "3%",
  },
  badgePrimary: {
    backgroundColor: "#337ab7",
    ":hover": {
      backgroundColor: "#337ab7",
    },
  },
  disappear: {
    display: "none",
  },
})



// WEBPACK FOOTER //
// /src/containers/Dashboard/Dashboard.js